import type { Margin, ZIndex } from 'types/styles';

import styled from 'styled-components';

interface Props extends Margin, ZIndex {
    width?: string;
}

export const MarginWrapper = styled.div<Props>`
    ${({ width }) => width && `width: ${width};`};
    ${({ margin }) => margin && `margin: ${margin};`};
    ${({ marginLeft }) => marginLeft && `margin-left: ${marginLeft};`};
    ${({ marginTop }) => marginTop && `margin-top: ${marginTop};`};
    ${({ marginRight }) => marginRight && `margin-right: ${marginRight};`};
    ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`};
    ${({ zIndex }) => (zIndex !== undefined ? `z-index: ${zIndex};` : ``)};
`;
